import React from 'react';
import Layout from '../components/Layout';
import TeamsManagement from '../components/TeamsManagement';

const Teams = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 font-['Manrope']">
            Equipos
          </h1>
          <p className="text-slate-500 mt-1">
            Gestiona equipos, asigna usuarios y KPIs
          </p>
        </div>
        
        <TeamsManagement />
      </div>
    </Layout>
  );
};

export default Teams;
